import { DefaultTheme, ThemeProps } from 'styled-components';
import { IThemeSemantics } from '../../types';

type ThemeSemanticsAccessor<S extends IThemeSemantics = IThemeSemantics, R = any> = (semantics: S) => R;

export function selectThemeSemantics<TP extends ThemeProps<DefaultTheme>>(
    accessor: ThemeSemanticsAccessor): (props: TP) => any {
    return ((props) => accessor(props.theme.semantics));
}
